import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControlLabel,
  Grid,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Select,
  MenuItem,
  makeStyles,
} from "@material-ui/core";
import { AUTORIZACIONES_PRACTICAS_ESTADOS } from '../../../utils/constants';
import { setearEstadoEnCantidadFechaPracticaDenuncia } from '../../../actions/autorizaciones/Autorizaciones';

const useStyles = makeStyles({
  cell: {
    paddingLeft: '5%'
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const ModalPracticaCantidadFecha = ({ open, disabled = false, pendiente = false, onClose, practica }) => {
  const classes = useStyles();  
  const dispatch = useDispatch();

  const { practicas = [], practicasPendientesDenuncia = [] } = useSelector(
    (state) => state.autorizaciones
  );
  const [items, setItems] = useState(pendiente 
    ? practicasPendientesDenuncia.find(s => s.idCodNom === practica.idCodNom)?.cantidadesFecha ?? []
    : practicas.find(s => s.idCodNom === practica.idCodNom)?.cantidadesFecha ?? []
  );

  useEffect(() => {
    setItems(pendiente
      ? practicasPendientesDenuncia.find(s => s.idCodNom === practica.idCodNom)?.cantidadesFecha ?? []
      : practicas.find(s => s.idCodNom === practica.idCodNom)?.cantidadesFecha ?? []
    );
  }, [practicasPendientesDenuncia, practicas, pendiente]);

  const [page] = useState(0);
  const [rowsPerPage] = useState(50);
  const [dense, setDense] = useState(true);

  const handleChangeEstado = (fecha, horario, idEstado) => {        
    dispatch( setearEstadoEnCantidadFechaPracticaDenuncia(practica.idCodNom, fecha, horario, idEstado, pendiente) );
  }


  return (
    <Dialog fullWidth maxWidth="md" open={open} >
      <DialogTitle>
        Práctica: &nbsp;
        <span style={{ fontStyle: "italic" }}>{`${practica?.practica?.codNom} - ${practica?.practica?.desNom}`}</span>
      </DialogTitle>
      <DialogContent>
        {Array.isArray(items) &&
          items?.length > 0 ? (
          <TableContainer component={Paper} style={{ overflowX: "auto"}}>
            <Table size={dense ? "small" : "medium"} >
              <TableHead>
                <TableRow>
                  {/* <TableCell>Codigo Nomenclador</TableCell> */}
                  <TableCell style={{ width: "10%" }}></TableCell>
                  <TableCell style={{ width: "15%"}} className={classes.cell}>Fecha</TableCell>
                  <TableCell style={{ width: "15%"}} className={classes.cell}>Hora</TableCell>
                  <TableCell style={{ width: "15%"}} className={classes.cell}>Cantidad</TableCell>
                  <TableCell style={{ width: "25%"}} className={classes.cell}>Estado</TableCell>
                  <TableCell style={{ width: "30%"}} className={classes.cell}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, i) => {
                    return (
                      <TableRow key={i}>
                        <TableCell className={classes.cell}>
                        </TableCell>
                        <TableCell className={classes.cell}>
                          {new Date(item.fecha).toLocaleString("es-AR", optionsfecha)}
                        </TableCell>
                        <TableCell className={classes.cell}>{item.horario}</TableCell>
                        <TableCell className={classes.cell}>{item.cant}</TableCell>
                        <TableCell className={classes.cell}>
                          <Select
                            style={{ width: "300px", maxHeight: 42 }}
                            name="item.idEstadoPracticaCantFecha"
                            value={item.idEstadoPracticaCantFecha}
                            onChange={(e) => handleChangeEstado(item.fecha, item.horario, e.target.value)}
                            disabled={disabled}
                          >
                            {Array.isArray(Object.entries(AUTORIZACIONES_PRACTICAS_ESTADOS)) &&
                              Object.entries(AUTORIZACIONES_PRACTICAS_ESTADOS)?.length > 0 &&
                              Object.entries(AUTORIZACIONES_PRACTICAS_ESTADOS)
                              .filter(s => s[1] !== AUTORIZACIONES_PRACTICAS_ESTADOS.TERMINADA)
                              .filter(s => s[1] !== AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE)
                              .map((estadoPractica) => (
                                <MenuItem
                                  key={estadoPractica[1]}
                                  value={estadoPractica[1]}
                                >
                                  {estadoPractica[0]}
                                </MenuItem>
                              ))}
                          </Select>
                        </TableCell>
                        <TableCell style={{ color: "red", fontWeight: "bold"}} className={classes.cell}>
                          {item.cant === 0 ? 'La cantidad debe ser mayor a 0' : ''}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography style={{ fontStyle: "italic", fontSize: "1.1rem", textAlign: 'center', marginBottom: 15}}>
            No hay cantidades cargadas
          </Typography>
        )}
        
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: items?.length > 0 ? "space-between" : "right",
              margin: "0.5rem 0",
            }}
          >
            {items?.length > 0 && (
              <FormControlLabel
                style={{ marginTop: 20 }}
                control={
                  <Switch
                    checked={dense}
                    onChange={(e) => setDense(e.target.checked)}
                  />
                }
                label="Tamaño compacto"
              />
            )}
            <div>
              <Button
                style={{ margin: "0 1rem", marginTop: 20 }}
                color="secondary"
                variant="contained"
                onClick={onClose}
              >
                {/* {disabled ? 'Cerrar' : 'Cancelar'} */}
                Cerrar
              </Button>
              {/* <Button
                style={{ margin: "0 1rem", marginTop: 20 }}
                onClick={handleSubmitHorarios}
                disabled={disabled}
                color="primary"
                variant="contained"
              >
                Confirmar
              </Button> */}
            </div>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
